<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="showModal"
      size="lg"
    >   
        <CForm id="import_form" method="POST" enctype="multipart/form-data">
            <CRow>                             
              <CCol md="12">
                <CInput
                  label="Archivo a Importar:"
                  :lazy="false"
                  :value.sync="$v.form.import_file.$model"
                  type="file"
                  name="import_file"
                  id="import_file"
                  placeholder=""
                  autocomplete="given-import_file"
                />
              </CCol>                            
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="importVehicules" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"

export default {
  name: 'VehiclesImportModal',
  props: {

  },
  components: {
    
  },
  data () {
    return {
      showModal: false,
      title: "Importar Activos",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
    }
  },
  mounted: async function() {    

  },
  methods: {
    importModal () {
      this.showModal = true;
      this.color = "info";
      this.title = 'Importar Activos';
      this.isEdit = false;
      this.submitted = false;

      this.form = {

      }
    },
    importVehicules () {
      let form = document.getElementById("import_form");
      let formData = new FormData(form);

      this.$emit("import", formData );

      this.closeModal();
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {

      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      import_file: {    

      }
    }
  },
}
</script>
<style>
  .input_code .form-control{
    text-align: center;
  }
</style>